// 统一管理 document.title
// 1. 路由切换时立刻写入该路由的基础标题（meta.title），不用等接口回来，避免上一个页面的标题残留
// 2. 接口回来后要覆盖标题的，必须带上发起请求时的路由标识；路由已经变了就丢弃，
//    否则详情页没跑完的请求会把文章标题写到首页上
export const DEFAULT_TITLE = '海平创新知识服务'

let currentKey = ''

export function routeKey (route) {
  return route ? route.fullPath : ''
}

// 路由切换时调用
export function resetTitle (route) {
  currentKey = routeKey(route)
  writeTitle((route && route.meta && route.meta.title) || DEFAULT_TITLE)
}

// 异步回调里调用，key 传请求发起时的 routeKey(this.$route)
export function setTitle (title, key) {
  if (!title || key !== currentKey) {
    return
  }
  writeTitle(title)
}

function writeTitle (title) {
  if (document.title === title) {
    return
  }
  document.title = title
  refreshIosTitle()
}

// iOS 微信/Safari 在 hash 路由下改 document.title 不会立刻刷新，
// 加载一次同域资源触发 WebView 重新读取标题
function refreshIosTitle () {
  if (!/iphone|ipad|ipod/i.test(navigator.userAgent)) {
    return
  }
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = '/favicon.ico'
  iframe.onload = function () {
    setTimeout(function () {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe)
      }
    }, 10)
  }
  document.body.appendChild(iframe)
}
